import './App.css'
import { BrowserRouter } from 'react-router-dom'
import AppRoutes from './AppRoutes'
import { initializeApp } from 'firebase/app'
import { config } from './Configs/firebase.config'
import { ConfigProvider, Layout, theme as antThemeLib } from 'antd'
import { Colors } from './common/constant'
import { ThemeProvider, useTheme } from './common/ThemeContext'

initializeApp(config.firebaseConfig)

// EDC_THEME: identical to the original ConfigProvider tokens before theme feature was added
const EDC_THEME = {
	token: {
		colorPrimary: Colors.Primary,
		colorText: Colors.Text,
		fontFamily: "'Times New Roman', Times, serif",
	},
}

const PRIMERSOFT_THEME = {
	token: {
		// Primersoft should not look like EDC blue; use neutral charcoal actions.
		colorPrimary: '#5b5f66',
		colorText: '#414042',
		colorInfo: '#5b5f66',
		colorLink: '#5b5f66',
		colorError: '#ED1C24',
		borderRadius: 8,
		fontFamily: 'CoreSansCR-45Regular, KantumruyPro-Regular, Helvetica, Arial, sans-serif',
	},
}

const DARK_THEME = {
	algorithm: antThemeLib.darkAlgorithm,
	token: {
		colorPrimary: '#38bdf8',
		colorBgBase: '#111827',
		colorBgContainer: '#0f172a',
		colorBgElevated: '#1e293b',
		colorTextBase: '#f8fafc',
		colorTextSecondary: '#cbd5e1',
		colorBorder: '#1e293b',
		borderRadius: 12,
		fontFamily: 'CoreSansCR-45Regular, KantumruyPro-Regular, Helvetica, Arial, sans-serif',
	},
}



function ThemedApp() {
	const { theme } = useTheme()

	let antTheme = EDC_THEME
	let bgColor = '#f0f2f5'

	if (theme === 'primersoft') {
		antTheme = PRIMERSOFT_THEME
		bgColor = '#f3f4f6'
	} else if (theme === 'dark') {
		antTheme = DARK_THEME
		bgColor = '#111827'
	}

	return (
		<ConfigProvider theme={antTheme}>
			<Layout style={{ minHeight: '100vh', backgroundColor: bgColor }}>
				<BrowserRouter>
					<AppRoutes />
				</BrowserRouter>
			</Layout>
		</ConfigProvider>
	)
}


function App() {
	return (
		<ThemeProvider>
			<ThemedApp />
		</ThemeProvider>
	)
}

export default App
